import React from 'react';
import styled from 'styled-components';
import { TrevorComponent } from '../../types';
import { Tooltip, TooltipProps } from '../Tooltip';

export type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: React.ReactNode;
  tooltip?: string;
  tooltipProps?: TooltipProps;
};

const DEFAULT_TOOLTIP_PROPS: TooltipProps = { place: 'top' };

export const IconButtonRaw: TrevorComponent<IconButtonProps> = ({
  icon,
  className,
  tooltip,
  tooltipProps = DEFAULT_TOOLTIP_PROPS,
  ...props
}) => (
  <>
    <button data-tooltip-id={tooltip} className={className} {...props}>
      {icon}
    </button>
    {tooltip && (
      <Tooltip id={tooltip} {...tooltipProps}>
        {tooltip}
      </Tooltip>
    )}
  </>
);

export const IconButton = styled(IconButtonRaw)`
  padding: 0;
  margin: 0;
  width: 33px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #e8e8e8;
  background-color: #fff;

  :disabled {
    opacity: 0.5;
  }

  &:not(:disabled):hover {
    cursor: pointer;
    border-color: #bebebe; // TODO: clarify with Erin
  }
`;
